// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app." + {"840":"8dd6985ce1d54dcb","961":"66b4d2197fec0758"}[chunkId] + ".js";
};